var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDrawer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icomoon-ignore"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.505 6.937h-14.969l-5.864 6.397v11.729h26.656v-11.729l-5.823-6.397zM9.005 8.003h14.029l4.852 5.331h-8.155c0 1.997-1.735 3.61-3.732 3.61s-3.732-1.613-3.732-3.61h-8.149l4.887-5.331zM28.262 23.997h-24.524v-9.596h7.596c0.51 2.041 2.441 3.609 4.666 3.609s4.156-1.569 4.666-3.61h7.596v9.596z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawer);
export default __webpack_public_path__ + "static/media/drawer.85c911342000cd618147d7ff06a82b05.svg";
export { ForwardRef as ReactComponent };